export default function preLoadImg(src, time) {
  if (!src) return;
  if (time) {
    setTimeout(() => {
      _preLoadImg(src);
    }, time);
  } else {
    _preLoadImg(src);
  }
}

function _preLoadImg(src) {
  let img = document.createElement('img');
  img.style.display = 'none';
  img.src = src;
  document.body.appendChild(img);
  document.body.removeChild(img);
}


// WEBPACK FOOTER //
// ./src/utils/preLoadImg.js